/** Dependencies */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/** Styles */
import {
  Avatar,
  Badge,
  Menu,
  MenuItem,
  Divider,
  IconButton,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

/** Hooks */
import useProfile from '../../hooks/useProfile';
import { expiredAccountStorage } from '../../services/tokenStorage';

export default function AccountLanguage() {
  const { setLanguage, meProfile } = useProfile();
  const { t, i18n } = useTranslation('layout');

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const cdnTrIcon = 'https://cdn-icons-png.flaticon.com/512/197/197518.png';
  const cdnEnIcon = 'https://cdn-icons-png.flaticon.com/512/197/197484.png';

  const token = expiredAccountStorage.getToken();

  useEffect(() => {
    if (meProfile) {
      i18n.changeLanguage(meProfile?.language);
    }
  }, [meProfile]);

  return (
    <>
      <IconButton
        size="large"
        aria-label="account"
        sx={{ color: grey[700], borderRadius: 0 }}
        onClick={handleClick}
        disabled={Boolean(token)}
      >
        <Badge>
          <Avatar
            sx={{ width: '22px', height: '22px' }}
            src={`${i18n.language === 'tr' ? cdnTrIcon : cdnEnIcon}`}
          />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => {
            if (i18n.language === 'en') {
              i18n.changeLanguage('tr');
              setLanguage('tr');
              setTimeout(() => window.location.reload(), 1500);
            }
          }}
        >
          <Avatar src={cdnTrIcon} />
          <p
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#181C32',
              fontSize: '14px',
              fontWeight: '500',
              marginLeft: '3px',
            }}
          >
            {t(`sidebar.language_tr`)}
            &nbsp;&nbsp; &nbsp;&nbsp;
            {i18n.language === 'tr' && (
              <DoneOutlinedIcon sx={{ color: 'green' }} />
            )}
          </p>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            if (i18n.language === 'tr') {
              i18n.changeLanguage('en');
              setLanguage('en');
              setTimeout(() => window.location.reload(), 1500);
            }
          }}
        >
          <Avatar src={cdnEnIcon} />
          <p
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#181C32',
              fontSize: '14px',
              fontWeight: '500',
              marginLeft: '3px',
            }}
          >
            {t(`sidebar.language_en`)}
            &nbsp;&nbsp; &nbsp;&nbsp;
            {i18n.language === 'en' && (
              <DoneOutlinedIcon sx={{ color: 'green' }} />
            )}
          </p>
        </MenuItem>
      </Menu>
    </>
  );
}
